import { forwardRef, type Ref, type SVGProps } from "react";
const IconCircleFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 2a14 14 0 1 0 0 28 14 14 0 1 0 0-28" />
  </svg>
);
const ForwardRef = forwardRef(IconCircleFilledSVG);
ForwardRef.displayName = "IconCircleFilled";
export { ForwardRef as IconCircleFilled };
